import * as React from "react";
import { cn } from "./utils";

interface LoaderProps extends React.ComponentProps<"div"> {
  size?: "sm" | "md" | "lg";
}

const sizeMap = {
  sm: 16,
  md: 32,
  lg: 48,
};

const borderSizeMap = {
  sm: 2,
  md: 3,
  lg: 4,
};

export function Loader({
  className,
  size = "md",
  style,
  ...props
}: LoaderProps) {
  const sizePx = sizeMap[size];
  const borderPx = borderSizeMap[size];

  const loaderStyle: React.CSSProperties = {
    width: `${sizePx}px`,
    height: `${sizePx}px`,
    border: `${borderPx}px solid #e5e7eb`,
    borderTop: `${borderPx}px solid #17265a`,
    borderRadius: "9999px",
    animation: "loader-spin 0.8s linear infinite",
    display: "inline-block",
    ...style,
  };

  return (
    <>
      <style>{`
        @keyframes loader-spin {
          from {
            transform: rotate(0deg);
          }
          to {
            transform: rotate(360deg);
          }
        }
      `}</style>
      <div
        className={cn(className)}
        style={loaderStyle}
        role="status"
        aria-label="Loading"
        {...props}
      >
        <span className="sr-only">Loading…</span>
      </div>
    </>
  );
}

interface FullPageLoaderProps {
  label?: string;
}

export function FullPageLoader({ label }: FullPageLoaderProps) {
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-white">
      <div className="flex flex-col items-center gap-4">
        <div className="flex items-center gap-3">
          <Loader size="lg" />
        </div>
        {label && <p className="text-sm text-gray-600 font-medium">{label}</p>}
      </div>
    </div>
  );
}
